import React, { CSSProperties } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import MailIcon from '@mui/icons-material/Mail';
import Logo, { eLogo } from '../Logo/Logo';
import StryderTheme from '../StryderTheme/StryderTheme';
import './stryder-stationery.css';

export interface StryderStationeryProps {
  /** Page content to render within the frame. */
  children: (JSX.Element | undefined) | (JSX.Element | undefined)[];
  /** Link to use for the logo, default "/" home page. */
  link?: string;
  /** Optional menu to render in the top-left. */
  menu?: JSX.Element;
  /** Optional title to set for the page. */
  title?: string | JSX.Element;
  /** Optional descriptive text. */
  description?: string | JSX.Element;
  /** Optional CSS class for content, default stryder-stationery-content. */
  contentClassName?: string;
  /** Optional switch to keep left align. */
  textAlign?: 'left' | 'center' | 'unset';
  /** Optional styles to apply to the container, e.g. maxWidth. */
  style?: CSSProperties;
}

/** Link for Contact Us button. */
const CONTACT_US = 'mailto:info@stryder.cloud';

const StryderStationery = (props: StryderStationeryProps) => {
  const { link, menu, title, description, contentClassName } = props;
  return (
    <StryderTheme>
      <div className="stryder-stationery-root">
        <div className="stryder-stationery-background"></div>
        <header>
          <Grid
            container
            direction="row"
            alignItems="center"
            className="stryder-stationery-header"
            wrap="nowrap"
          >
            {menu && <Grid item>{menu}</Grid>}
            <Grid item style={{ flexGrow: 1 }}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                wrap="nowrap"
              >
                <Grid item>
                  <a href={link || '/'} style={{ textDecoration: 'none' }}>
                    <Logo
                      height={60}
                      logo={eLogo.mono}
                      className="header-logo"
                    />
                  </a>
                </Grid>
                <Grid item>
                  <Button
                    color="primary"
                    variant="contained"
                    className="screen-full"
                    href={CONTACT_US}
                  >
                    Contact Us
                  </Button>
                  <IconButton
                    color="primary"
                    className="screen-small"
                    href={CONTACT_US}
                  >
                    <Tooltip title="Contact us">
                      <MailIcon />
                    </Tooltip>
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </header>

        <div className="stryder-stationery-scroll">
          <div
            className={contentClassName || 'stryder-stationery-content'}
            style={{ ...props.style, textAlign: props.textAlign || 'center' }}
          >
            {title && (
              <Typography
                variant="h4"
                color="primary"
                className="stryder-stationery-title"
              >
                {title}
              </Typography>
            )}
            {description && (
              <Typography className="stryder-stationery-description">
                {description}
              </Typography>
            )}
            {props.children}
          </div>
        </div>
      </div>
    </StryderTheme>
  );
};

export default StryderStationery;
